import React from 'react';
import Layout from './components/LayoutItems/Layout';
import About from './components/BodyItems/About';
import Schedule from './components/BodyItems/Schedule/Schedule';
import Container from 'react-bootstrap/Container';

export default () => (
    <Layout>
        <Container className="wow-container wow-body-container bg-light text-center">
            <h2>January 12 - 31, 2026</h2>
        </Container>
        <About />
        <Schedule />
    </Layout>
);
